import React from 'react';
import SingleServiceTwo from '../../components/Service/SingleServiceTwo';

import shapeImg1 from '../../assets/img/service/sv-shape-5.png';
import shapeImg2 from '../../assets/img/service/sv-shape-6.png';
import shapeImg3 from '../../assets/img/service/sv-shape-7.png';
import shapeImg4 from '../../assets/img/service/sv-shape-8.png';
import shapeImg5 from '../../assets/img/service/sv-shape-9.png';

const Service = () => {
  return (
    <div className="service-2__area service-2__space service-2__plr grey-bg p-relative">
      <div className="service-2__shape-1 d-none d-xxl-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="service-2__shape-2 d-none d-xxl-block">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="service-2__shape-3 d-none d-md-block">
        <img src={shapeImg3} alt="" />
      </div>
      <div className="service-2__shape-4 d-none d-xl-block">
        <img src={shapeImg4} alt="" />
      </div>
      <div className="service-2__shape-5 d-none d-lg-block">
        <img src={shapeImg5} alt="" />
      </div>
      <div className="container-fluid">
        <div className="row align-items-end mb-60">
          <div
            className="col-xl-6 col-lg-6 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <div className="service-2__section-box">
              <h4
                className="section-subtitle char-anim wow animate__fadeInUp align-items-center"
                data-wow-duration="1.1s"
                data-wow-delay=".3s"
              >
               <b> Why We're Different </b>
              </h4>
              <h3 className="section-title char-anim">
                How does TGVC Technologies <br />
                Stand Different from others? 
              </h3>
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="service-2__top-text pt-35">
              <p className="mb-0 char-anim-2">
                We don’t just deliver services — we engineer smart solutions tailored to your business goals. What sets us apart is our commitment to innovation, agility, and outcomes. Whether you're a startup or an enterprise, we bring deep technical expertise, transparent collaboration, and future-ready strategies that make a measurable impact.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-6 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleServiceTwo 
              Icon="fa-lightbulb-on" 
              Title="Cloud-ready & AI-powered" 
              Description="Build smart, future-ready apps powered by cloud infrastructure and intelligent automation."/>
          </div>
          <div
            className="col-xl-6 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".8s"
          >
            <SingleServiceTwo Icon="fa-globe" Title="Product-first, Fast Prototyping" 
            Description="We prioritize real user needs and validate ideas fast through agile prototyping and iteration."/>
          </div>
          <div
            className="col-xl-6 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".9s"
          >
            <SingleServiceTwo
              Icon="fa-signal-4"
              Title="End-to-end full-stack delivery"
              Description="From intuitive UI/UX to robust backend systems, we deliver complete, end-to-end solutions."
            />
          </div>
          <div
            className="col-xl-6 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".9s"
          >
            <SingleServiceTwo
              Icon="fa-hand-holding-water"
              Title="Built for speed, security & scale"
              Description="We deliver high-performance solutions that are secure, scalable, and built to last."
            />
          </div>
          <div
            className="col-xl-6 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.0s"
          >
            <SingleServiceTwo Icon="fa-bullhorn" Title="Personalized, agile support" 
            Description="Get dedicated support with clear communication, fast response times, and tailored guidance."/>
          </div>
          <div
            className="col-xl-6 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.1s"
          >
            <SingleServiceTwo
              Icon="fa-user-headset"
              Title="Data-driven decision making"
              Description="We leverage analytics and insights to guide every stage of development and growth."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
